import React from 'react';
import { Link } from 'react-router-dom';

const BackButton = ({ styles }) => {
  return (
    <Link
      to={{ pathname: '/' }}
      style={{
        padding: '10px 20px',
        backgroundColor: 'rgb(247,247,247)',
        color: 'black',
        ...styles
      }}
    >
      <p style={{ fontFamily: 'EffraRegular' }}>Back</p>
    </Link>
  );
};
export default BackButton;
